<template>
    <div ref="chartContainer" class="chart-container"></div>
</template>
<script>
// import * as echarts from 'echarts'
import dayjs from 'dayjs'
export default {
    data() {
        return {
            chartInstance: null, // ECharts实例
            // 图表数据
            chartData: {
                timeData: [],
                speedData: [], // 时速数据
                rpmData: []    // 电机转速数据
            },
            zoomPercent: 100, // 缩放百分比
            minZoom: 30,     // 最小缩放百分比
            maxZoom: 150     // 最大缩放百分比
        }
    },
    mounted() {
        // 初始化图表
        this.initChart()
        // 加载初始数据
        this.loadChartData()
        // 监听窗口大小变化，自适应图表
        window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy() {
        // 销毁图表实例，释放资源
        if (this.chartInstance) {
            this.chartInstance.dispose()
        }
        // 移除事件监听
        window.removeEventListener('resize', this.handleResize)
    },
    methods: {
        // 初始化图表实例
        initChart() {
            this.chartInstance = echarts.init(this.$refs.chartContainer)
        },

        // 加载图表数据
        loadChartData() {
            // 模拟从接口获取数据
            this.generateMockData()
            // 更新图表
            this.updateChart()
        },

        // 生成模拟数据
        generateMockData() {
            const baseTime = dayjs().subtract(1, 'hour')
            const timeData = []
            const speedData = []
            const rpmData = []

            // 生成10个时间点数据
            for (let i = 0; i < 10; i++) {
                // 时间每隔3分钟
                const time = baseTime.add(i * 3, 'minute').format('YYYY-MM-DD HH:mm:ss')
                timeData.push(time)

                // 随机时速(0-80)
                speedData.push(Math.floor(Math.random() * 80))

                // 随机电机转速(1000-3000)
                rpmData.push(1000 + Math.floor(Math.random() * 2000))
            }

            this.chartData = { timeData, speedData, rpmData }
        },

        // 更新图表配置
        updateChart() {
            const { timeData, speedData, rpmData } = this.chartData

            // 组装系列数据
            const seriesSpeed = timeData.map((time, index) => [time, speedData[index]])
            const seriesRpm = timeData.map((time, index) => [time, rpmData[index]])

            // 计算最大速度和转速
            const maxSpeed = Math.max(...speedData)
            const maxRpm = Math.max(...rpmData)

            const option = {

                legend: {
                    data: ['时速(km/h)', '电机转速(r/min)'],
                    top: 20,
                    left: 'center'
                },
                // 缩放配置 - 关键部分
                // dataZoom: [
                //   // 内置型：可在图表内部拖拽缩放
                //   {
                //     type: 'inside', // 内置缩放（鼠标滚轮和拖拽）
                //     xAxisIndex: 0,  // 作用于x轴
                //     start: 0,       // 初始缩放开始位置（0-100）
                //     end: 100,       // 初始缩放结束位置（0-100）
                //     zoomOnMouseWheel: 'shift', // 按住shift键+滚轮缩放
                //     moveOnMouseMove: true,     // 鼠标移动时平移
                //     moveOnMouseWheel: false    // 滚轮是否触发平移
                //   },
                //   // 滑动条型：底部滑动条缩放
                //   {
                //     type: 'slider', // 滑动条缩放
                //     xAxisIndex: 0,  // 作用于x轴
                //     start: 0,       // 初始缩放开始位置
                //     end: 50,        // 初始显示50%的数据范围（更适合展示缩放效果）
                //     height: 10,     // 滑动条高度
                //     bottom: 10,     // 距离底部位置
                //     borderColor: 'transparent',
                //     backgroundColor: '#f0f0f0',
                //     fillerColor: 'rgba(135, 206, 235, 0.6)',
                //     handleColor: '#2196f3'
                //   }
                // ],
                dataZoom: [
                    {
                        type: 'inside',
                        start: 0,
                        end: 100
                    },
                    {
                        start: 0,
                        end: 100
                    }
                ],
                tooltip: {
                    trigger: 'axis',
                    formatter: params => {
                        const time = dayjs(params[0].axisValue).format('HH:mm:ss')
                        let html = `<div>闽D96592</div>`
                        html += `<div>时间：${time}</div>`
                        params.forEach(item => {
                            const unit = item.seriesName.match(/\((.*?)\)/)[1]
                            html += `<div>${item.seriesName}：${item.value[1]} ${unit}</div>`
                        })
                        return html
                    },
                    axisPointer: { type: 'cross' }
                },
                xAxis: {
                    type: 'time',
                    axisLabel: {
                        formatter: value => dayjs(value).format('HH:mm:ss')
                    },
                    axisLine: { lineStyle: { color: '#ccc' } },
                    splitLine: { show: false }
                },
                yAxis: [
                    {
                        type: 'value',
                        name: '时速(km/h)',
                        min: 0,
                        max: 80,
                        axisLabel: { formatter: '{value} km/h' },
                        axisLine: { lineStyle: { color: '#ff9800' } },
                        splitLine: {
                            show: true,
                            lineStyle: { type: 'dashed', color: '#eee' }
                        }
                    },
                    {
                        type: 'value',
                        name: '电机转速(r/min)',
                        min: 0,
                        max: 3000,
                        axisLabel: { formatter: '{value} r/min' },
                        axisLine: { lineStyle: { color: '#2196f3' } },
                        splitLine: { show: false },
                        position: 'right'
                    }
                ],
                series: [
                    {
                        name: '时速(km/h)',
                        type: 'line',
                        data: seriesSpeed,
                        yAxisIndex: 0,
                        itemStyle: { color: '#ff9800' },
                        smooth: true,
                        markArea: {
                            data: [
                                [
                                    { xAxis: timeData[3] },
                                    { xAxis: timeData[5] }
                                ]
                            ],
                            itemStyle: { color: 'rgba(135,206,235,0.3)' }
                        }
                    },
                    {
                        name: '电机转速(r/min)',
                        type: 'line',
                        data: seriesRpm,
                        yAxisIndex: 1,
                        itemStyle: { color: '#2196f3' },
                        smooth: true
                    }
                ]
            }

            this.chartInstance.setOption(option)
        },

        // 刷新数据
        refreshData() {
            this.generateMockData()
            this.updateChart()
        },

        // 处理窗口大小变化
        handleResize() {
            if (this.chartInstance) {
                this.chartInstance.resize()
            }
        }
    }
}
</script>
<style scoped>
.chart-container {
    width: 100%;
    height: 400px;
    /* 图表高度 */
}
</style>
